import classNames from 'classnames';
import React from 'react';

import Heading from '@jpp/atoms/Heading';
import Loading from '@jpp/atoms/Loading';
import ModalCore from '@jpp/organisms/Modal';
import { IModalChildProps } from '@jpp/organisms/Modal/ModalCore';
import { EPriority, ETheme } from 'common/typings/enums';

import './SubmittingPaymentModal.scss';

const ROOT_CLASSNAME = 'SubmittingPaymentModal';

const SubmittingPaymentModal: React.FunctionComponent<IModalChildProps> = ({
  className,
  isVisible = false,
  bodyOverflow,
  onClose,
}) => {
  return (
    <ModalCore
      isVisible={isVisible}
      hasOverlayClose={false}
      bodyOverflow={bodyOverflow}
      className={classNames(ROOT_CLASSNAME, className)}
      onClose={onClose}
      hasCloseIcon={false}
    >
      <Heading
        priority={EPriority.Three}
        className={`${ROOT_CLASSNAME}__heading`}
      >
        We are submitting your payment
      </Heading>

      <div className={`${ROOT_CLASSNAME}__loading-wrapper`}>
        <Loading
          theme={ETheme.Brand}
          className={`${ROOT_CLASSNAME}__loading`}
        />
      </div>

      <p className={`${ROOT_CLASSNAME}__copy`}>
        Please do not refresh the page or close this tab.
      </p>
    </ModalCore>
  );
};

export default SubmittingPaymentModal;
